import React, { useEffect, useState, useImperativeHandle } from 'react'
import YourCapacity from "@/components/fileBrowser/YourCapacity";
import { nubisDriveCapacityAPI } from "@/apis/nubisDriveCapacityAPI";
import { transformedFormatBytes } from "@/helpers/formatBytesTransformer";
import * as localforage from "localforage";

const Capacity = React.forwardRef((props, ref) => {
  const [refreshCapacity, setRefreshCapacity] = useState(false);
  const [barValue, setBarValue] = useState(0);
  const [usageValue, setUsageValue] = useState("-");
  const [storageValue, setStorageValue] = useState("-");
  const [isFECHQ, setIsFECHQ] = useState(false);
  const [capacity, setCapacity] = useState({});
  const [companyId, setCompanyId] = useState();
  const [availableStorage, setAvailableStorage] = useState("");

  useImperativeHandle(ref, () => ({
    refresh: () => {
      setRefreshCapacity(true);
    }
  }))

  const getCapacityData = async () => {
    setRefreshCapacity(false);

    let capacityObj = await nubisDriveCapacityAPI();
    let userData = await localforage.getItem("user");
    let companyId = await localforage.getItem("companyId");
    setCompanyId(companyId);
    setCapacity(capacityObj);

    if (capacityObj && userData) {
      let used = transformedFormatBytes(capacityObj.used);
      let total = transformedFormatBytes(capacityObj.total);
      let isParentCompanyNull = !userData.company.parent_company_id;
      let availableStorage = capacityObj.total - capacityObj.used;

      setAvailableStorage(availableStorage);
      setUsageValue(used);

      if (isParentCompanyNull) {
        setIsFECHQ(true);
        setBarValue(Number(capacityObj.used));
        setStorageValue("unlimited");
      } else {
        let percentage = (capacityObj.used / capacityObj.total) * 100;
        setBarValue(percentage);
        setStorageValue(total);

        if (props.onCapRefresh) {
          props.onCapRefresh(capacityObj.total - capacityObj.used)
        }
      }

      // stored the available storage for file uploading validation
      await localforage.setItem(
        `${companyId}-availableStorage`,
        availableStorage
      );
    }
  };

  const getAvailableStorageData = async () => {
    if (!isFECHQ) {
      let availableStorage = await localforage.getItem(
        `${companyId}-availableStorage`
      );
      setAvailableStorage(availableStorage);
    } else {
      setAvailableStorage("unlimited");
    }
  };

  useEffect(() => {
    getCapacityData();
    getAvailableStorageData();
  }, [])

  return (
    <YourCapacity
      capacity={capacity}
      barValue={barValue}
      usageValue={usageValue}
      storageValue={storageValue}
      getCapacityData={getCapacityData}
      refreshCapacity={refreshCapacity}
    />
  )
})

export default Capacity